import { formatToTitleCase } from './format-to-title-case';

import { Honorific } from '@/types/enums/honorific.enum';

type Professional = {
  honorific: string;
  name: string;
};

export const professionalDisplayName = (professional: Professional) => {
  if (!professional.honorific) {
    return formatToTitleCase(professional.name);
  }

  return formatToTitleCase(`${professional.honorific} ${professional.name}`);
};

const FEMININE_HONORIFICS = [Honorific.DRA, Honorific.SRA];

export function getProfessionalArticle(displayName: string): 'a' | 'o' {
  return FEMININE_HONORIFICS.some((honorific) => displayName.startsWith(honorific)) ? 'a' : 'o';
}
